import React from "react";
import { Link } from "react-router-dom";
import * as LucideIcons from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function CategoriesGrid() {
  const { categories } = useApp();
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 mt-8">
      <div className="flex items-end justify-between mb-4">
        <h2 className="text-xl md:text-2xl font-black text-white">Categorii populare</h2>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {categories.map((c) => {
          const Icon = LucideIcons[c.icon] || LucideIcons.Tag;
          return (
            <Link key={c.id} to={`/categorie/${c.id}`} className="amd-card rounded-lg overflow-hidden group">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={c.image} alt={c.name} loading="lazy" className="w-full h-full object-cover opacity-50 group-hover:opacity-80 group-hover:scale-105 transition-all duration-500" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(0,0,0,0.1) 0%, rgba(0,0,0,0.85) 100%)" }} />
                <div className="absolute inset-0 p-3 flex flex-col justify-between">
                  <div className="w-9 h-9 rounded-md grid place-items-center" style={{ background: "var(--amd-primary)" }}>
                    <Icon className="w-5 h-5 text-white" />
                  </div>
                  <div className="font-semibold text-white text-sm leading-snug">{c.name}</div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
